import { Languages } from '../languages'

export enum ApiMessages {
  ENERGY_DATA_PARAGRAPH_1 = 'ENERGY_DATA_PARAGRAPH_1',
  ENERGY_DATA_PARAGRAPH_INFO_1 = 'ENERGY_DATA_PARAGRAPH_INFO_1',
  ENERGY_DATA_PARAGRAPH_INFO_2 = 'ENERGY_DATA_PARAGRAPH_INFO_2',
  ENERGY_DATA_PARAGRAPH_INFO_3 = 'ENERGY_DATA_PARAGRAPH_INFO_3',
  ENERGY_DATA_PARAGRAPH_WARNING_1 = 'ENERGY_DATA_PARAGRAPH_WARNING_1',
  ENERGY_DATA_PARAGRAPH_WARNING_2 = 'ENERGY_DATA_PARAGRAPH_WARNING_2',
  ENERGY_DATA_PARAGRAPH_WARNING_3 = 'ENERGY_DATA_PARAGRAPH_WARNING_3',
  ENERGY_DATA_EXPORT_PARAGRAPH_INFO_1 = 'ENERGY_DATA_EXPORT_PARAGRAPH_INFO_1'
}

export type IncludedApiMessages = {
  [P in ApiMessages]: {
    [P in Languages]: string
  }
}

export const translatedApiMessages: IncludedApiMessages = {
  [ApiMessages.ENERGY_DATA_PARAGRAPH_1]: {
    en:
      'Energy Data API provides open data on various entities within Elhub, including price areas (Market Balance Area), grid areas, parties, metering points, consumption groups, production groups, and associated aggregated consumption/production data.' +
      ' For detailed information about each endpoint, please click on the respective entity.'
  },

  [ApiMessages.ENERGY_DATA_PARAGRAPH_INFO_1]: {
    en: 'This API returns JSON in the JSON:API v1.1 format. Visit the'
  },

  [ApiMessages.ENERGY_DATA_PARAGRAPH_INFO_2]: {
    en: 'JSON:API website'
  },

  [ApiMessages.ENERGY_DATA_PARAGRAPH_INFO_3]: {
    en: 'for more information on how to consume the JSON responses.'
  },

  [ApiMessages.ENERGY_DATA_PARAGRAPH_WARNING_1]: {
    en: 'This is a v0 API. Breaking changes may come to the API endpoints in the future'
  },

  [ApiMessages.ENERGY_DATA_PARAGRAPH_WARNING_2]: {
    en: 'You will need to authenticate to Maskinporten in order to use this API. For more information check the '
  },

  [ApiMessages.ENERGY_DATA_PARAGRAPH_WARNING_3]: {
    en: 'Maskinporten instructions on how to set up your access'
  },

  [ApiMessages.ENERGY_DATA_EXPORT_PARAGRAPH_INFO_1]: {
    en: 'This API returns a file in CSV only. The exports are generated once a day and available after midnight.'
  }
}
